import React, { Fragment, ReactNode } from 'react';

import { Box } from '../../../../../Box';
import { Typography } from '../../../../../Typography';

interface GroupProps {
  key: number;
  group: string;
  children?: ReactNode;
}

export const Group = ({ key, group, children }: GroupProps) => {
  return (
    <Fragment key={key}>
      <Box px="16" pt="8" pb="4">
        <Typography
          component="span"
          variant="caption"
          color="text.light.tertirary"
        >
          {group}
        </Typography>
      </Box>
      <Box>{children}</Box>
    </Fragment>
  );
};
